/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.ready(() => App.replies.init());


App.replies = {
  init() {
    App.subscribe("account_membership.replies.updated", App.replies.updated);
    return App.replies.show();
  },


  hide() {
    document.title = document.title.replace(/^\(\d+\) /, "");
    return $(".js-new-messages-badge").text("").removeClass("active");
  },



  // Show the unread replies counter unless we're on the messages tab
  // and "all" group already
  // evt.detail: { reply_count: reply_count }
  updated(evt) {
    // console.log "App.replies.updated, ", evt

    const data = evt.detail;
    const current_group_id = App.groups.current_id();
    const all_group_id     = App.groups.all_group_id();

    if (!App.messages.on_messages_view() || (current_group_id !== all_group_id)) {
      return App.replies.set(data.reply_count);
    }
  },


  set(count) {
    localStorage.reply_count = count;
    return App.replies.show();
  },


  show(evt) {
    App.replies.try_reset();

    if (App.replies.reply_count()) {
      $(".js-new-messages-badge").text(App.replies.reply_count()).addClass("active");
      return document.title = `(${App.replies.reply_count()}) ` + document.title.replace(/.+txtsignal/, "txtsignal");
    } else {
      document.title = document.title.replace(/^\(\d+\) /, "");
      return $(".js-new-messages-badge").text("").removeClass("active");
    }
  },


  reply_count() {
    if (localStorage.reply_count) {
      return parseInt(localStorage.reply_count, 10);
    } else {
      return 0;
    }
  },


  reset() {
    return delete localStorage.reply_count;
  },


  try_reset() {
    if (App.messages.on_messages_view() && App.groups.is_all_group()) {
      return App.replies.reset();
    }
  }
};
